import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormField } from '../components/Form/FormField.js';
import { FAIcon } from '../components/fa-icon/component.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
var FloatingLabelFormField = /*#__PURE__*/function (_React$Component) {
  function FloatingLabelFormField(props) {
    var _this;
    _classCallCheck(this, FloatingLabelFormField);
    _this = _callSuper(this, FloatingLabelFormField, [props]);
    _defineProperty(_this, "onFocus", function () {
      if (typeof _this.childFocus === 'function') {
        _this.childFocus();
      }
      _this.setState({
        toggled: true
      });
    });
    _defineProperty(_this, "onChange", function (value) {
      if (typeof _this.childChange === 'function') {
        _this.childChange(value);
      }
      if (typeof _this.props.onChange === 'function') {
        _this.props.onChange(value);
      }
      _this.setPopulated(value);
    });
    _defineProperty(_this, "onBlur", function (value) {
      if (typeof _this.childBlur === 'function') {
        _this.childBlur(value);
      }
      if (typeof _this.props.onBlur === 'function') {
        _this.props.onBlur(value);
      }
      _this.setPopulated(value);
      _this.setState({
        toggled: false
      });
    });
    _defineProperty(_this, "onDataLoaded", function (value) {
      _this.setPopulated(value);
    });
    _defineProperty(_this, "setPopulated", function (value) {
      var present = !!value;
      if (value instanceof Array) {
        present = value.length > 0;
      }
      if (_this.state.populated !== present) {
        _this.setState({
          populated: present
        });
      }
    });
    _defineProperty(_this, "renderField", function () {
      if (_this.props.children) {
        var child = React.Children.only(_this.props.children);
        _this.childBlur = child.props.onBlur;
        _this.childChange = child.props.onChange;
        _this.childFocus = child.props.onFocus;
        _this.childType = child.type;
        _this.fieldClassName = child.props.fieldClassName;
        return /*#__PURE__*/React.cloneElement(child, {
          onBlur: _this.onBlur,
          onChange: _this.onChange,
          onFocus: _this.onFocus,
          onDataLoaded: _this.onDataLoaded
        });
      }
    });
    var populated = props.dataValue !== undefined && props.dataValue !== null && props.dataValue !== '';
    _this.state = {
      toggled: false,
      populated: populated
    };
    return _this;
  }
  _inherits(FloatingLabelFormField, _React$Component);
  return _createClass(FloatingLabelFormField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        as = _this$props.as,
        className = _this$props.className,
        disabled = _this$props.disabled,
        labelClassName = _this$props.labelClassName,
        populatedOverride = _this$props.populatedOverride,
        searchField = _this$props.searchField,
        tooltip = _this$props.tooltip;
      var _this$state = this.state,
        populated = _this$state.populated,
        toggled = _this$state.toggled;
      var wrapperClassName = _formatClassName(['fg-line', 'ui-default', 'regular', as, this.fieldClassName, {
        'fg-disabled': disabled
      }, {
        'fg-populated': !populatedOverride && populated
      }, {
        'fg-toggled': toggled
      }, {
        'fg-tooltip': tooltip
      }]);
      var labelClass = _formatClassName([labelClassName, 'fg-label']);
      return /*#__PURE__*/React.createElement(FormField, _extends({}, this.props, {
        className: className + ' fg-float',
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        inputClassName: "fg-input",
        tooltip: tooltip,
        searchField: searchField ? /*#__PURE__*/React.createElement(FAIcon, {
          icon: "search"
        }) : null,
        labelClassName: labelClass,
        wrapperClassName: wrapperClassName
      }), this.renderField());
    }
  }]);
}(React.Component);
_defineProperty(FloatingLabelFormField, "propTypes", {
  children: PropTypes.any,
  className: PropTypes.string,
  as: PropTypes.string,
  dataValue: PropTypes.any,
  disabled: PropTypes.bool,
  isFloatOutside: PropTypes.bool,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  populatedOverride: PropTypes.bool,
  searchField: PropTypes.bool,
  tooltip: PropTypes.string
});
_defineProperty(FloatingLabelFormField, "defaultProps", {
  disabled: false
});
FloatingLabelFormField.displayName = "FloatingLabelFormField";
export { FloatingLabelFormField };